import { Box, Typography } from "@mui/material";
import React from "react";
import { formatCompactNumber } from "../utils/format.util";

export interface StatTileProps {
  label: string;
  value: number;
  icon: React.ReactNode;
}

export const StatTileComponent: React.FC<StatTileProps> = ({
  label,
  value,
  icon,
}) => {
  return (
    <Box
      sx={{
        flex: "1 1 200px",
        minWidth: 0,
        backgroundColor: "#FFFDF7",
        borderRadius: "14px",
        padding: "18px 20px",
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
      }}
    >
      <Box
        sx={{
          width: 44,
          height: 44,
          borderRadius: "12px",
          background: "linear-gradient(135deg, #A0005C, #FF0080)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          flexShrink: 0,
        }}
      >
        {icon}
      </Box>
      <Box sx={{ minWidth: 0 }}>
        <Typography
          sx={{
            fontSize: "12px",
            color: "#777",
            fontWeight: 600,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {label}
        </Typography>
        <Typography
          sx={{
            fontSize: "1.6rem",
            fontWeight: 700,
            color: "#2d2d2d",
            lineHeight: 1.2,
          }}
        >
          {formatCompactNumber(value)}
        </Typography>
      </Box>
    </Box>
  );
};
